import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";
import { axiosWithAuth } from "../Helpers/AxiosWithAuth";
import { useHistory } from "react-router";
import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Create, DeleteRounded } from "@material-ui/icons";

const styles = {
	borderRadius: "1rem",
	border: "3px dotted #000000",
	padding: "10px",
	margin: "10px auto",
	width: "40%",
};

const Recipe = ({ props }) => {
	const { push } = useHistory();
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleDelete = (e) => {
		e.preventDefault();
		setOpen(false);
		axiosWithAuth()
			.delete(`/api/recipes/${props.recipe_id}`)
			.then((res) => {
				push(`/`);
			});
	};

	return (
		<div className="Recipe-Conatainer" style={styles}>
			<Button variant="contained" color="primary">
				<Link style={{ textDecoration: "none", color: "white" }} to="/">
					Back
				</Link>
			</Button>
			<h2> Recipe Title: {props.recipe_title}</h2>
			<img
				id="RecipeImage"
				width="50%"
				src={props.image}
				alt={props.recipe_title}
			/>
			<h3> Recipe Source: {props.recipe_source}</h3>
			<p>Ingredients: {props.ingredients}</p>

			<p> Instructions: {props.instructions}</p>
			<Button variant="contained" color="primary" startIcon={<Create />}>
				<Link
					style={{ textDecoration: "none", color: "white" }}
					to={`/recipes/edit/${props.recipe_id}`}
				>
					Edit
				</Link>
			</Button>
			<br></br>
			<Button
				value={props.recipe_id}
				variant="contained"
				color="secondary"
				onClick={handleClickOpen}
				startIcon={<DeleteRounded />}
			>
				Delete Recipe
			</Button>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{"Delete Recipe?"}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						Are you sure you want to delete this recipe? This cannot be undone.
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose}>No</Button>
					<Button onClick={handleDelete} autoFocus>
						Yes
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default Recipe;
